import styled, { css } from 'styled-components'

import { MEDIA_QUERY } from '../../../../../styles'
import { MarginProps, margin } from '../../../../../styles/margin'
import { ResultSimpleRowProps, RowDirection } from './ResultSimpleRow'

interface AdditionalContainerProps {
  clickable: boolean
}

interface ResultContainerProps
  extends Pick<ResultSimpleRowProps, 'flexGrow' | 'withBorder' | 'background' | 'ignoreRadius'>,
    AdditionalContainerProps,
    MarginProps {}

export const Container = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    !['flexGrow', 'background', 'ignoreRadius', 'clickable', 'withBorder', 'mt', 'mb', 'mr', 'ml', 'm'].includes(prop)
})<ResultContainerProps>`
  flex-grow: ${({ flexGrow }) => flexGrow};
  cursor: ${({ clickable }) => clickable && 'pointer'};
  ${({ background, theme }) =>
    background === 'grey' &&
    css`
      margin: 0;
      background: ${theme.colors.background.grey};
      color: ${theme.colors.font.dark};
    `};
  &:nth-child(1) {
    ${({ ignoreRadius }) => (ignoreRadius ? 0 : ' 10px 10px 0 0')};
  }
  &:nth-last-child(1) {
    border-radius: ${({ ignoreRadius }) => (ignoreRadius ? 0 : '0 0 10px 10px')};
  }
  ${margin}
`
export const Label = styled.div<{ $flexDirection: RowDirection }>`
  white-space: pre-line;
  text-align: ${({ $flexDirection }) => ($flexDirection === 'row' ? 'left' : 'center')};
`

export const Content = styled('div').withConfig({
  shouldForwardProp: (prop) => !['withBorder', 'flexDirection', 'background', 'lineHeight'].includes(prop)
})<
  Pick<ResultSimpleRowProps, 'withBorder' | 'background' | 'lineHeight'> & {
    flexDirection: RowDirection
  }
>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
  justify-content: space-between;
  align-items: center;
  padding: ${({ lineHeight }) => (lineHeight === 'xs' ? '5px 0' : '20px 0')};
  margin: 0 30px;
  height: 100%;
  border-bottom: ${({ withBorder, theme, background }) => {
    return withBorder
      ? `1px solid ${
          background === 'default' ? theme.colors.common.regular.brightBlue : theme.colors.common.regular.stone
        }`
      : 'none'
  }};
  @media ${MEDIA_QUERY.MOBILE} {
    margin: 0 20px;
  }
`

export const Value = styled.div``
